export default __webpack_public_path__ + "static/media/time slot.ecc97e2b.svg";